import { Link } from "react-router-dom";
import { Waves } from "lucide-react";
import { useLang } from "./LangContext";
import { STR } from "../lib/i18n";

export default function Footer() {
  const { lang } = useLang();
  const t = STR[lang];
  return (
    <footer data-testid="site-footer" className="bg-[#0F1412] text-[#EBE9E0]">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-[#C98755]">
              <Waves className="h-5 w-5" strokeWidth={1.5} />
              <span className="font-serif text-2xl font-semibold tracking-tight">Sportfiskevatten</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#8A998E]">{t.footer.tagline}</p>
          </div>
          <nav className="flex gap-8">
            <Link to="/" data-testid="footer-home-link" className="overline-label text-[#8A998E] transition-colors duration-300 hover:text-[#C98755]">
              {t.nav.home}
            </Link>
            <Link to="/reportage" data-testid="footer-reportage-link" className="overline-label text-[#8A998E] transition-colors duration-300 hover:text-[#C98755]">
              {t.nav.reportage}
            </Link>
            <Link to="/redaktion" data-testid="footer-admin-link" className="overline-label text-[#8A998E] transition-colors duration-300 hover:text-[#C98755]">
              {t.nav.admin}
            </Link>
            <button
              type="button"
              data-testid="footer-cookie-settings"
              onClick={() => window.dispatchEvent(new Event("sfv-open-consent"))}
              className="overline-label text-[#8A998E] transition-colors duration-300 hover:text-[#C98755]"
            >
              {t.footer.cookieSettings}
            </button>
          </nav>
        </div>
        <div className="mt-16 border-t border-[#28332E] pt-8 text-xs tracking-widest text-[#8A998E]">
          © {new Date().getFullYear()} Sportfiskevatten – {t.footer.copyright}
        </div>
      </div>
    </footer>
  );
}
